import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WBSButton } from '@/common/WBSButton';
import FollowUpNetworkMapView from '@/follow-up-network/FollowUpNetworkMapView';
import { PageContainer } from '~/styles/boardStyles';
import { GroupHeaderWrapper, Title } from '~/styles/layoutElements';

export const Route = createFileRoute('/_app/follow-up-network/map')({
  component: FollowUpNetworkMapScreen,
});

/**
 * The Follow-up Network map. Its heading differs from the list's, which is why
 * each child route carries its own header.
 */
function FollowUpNetworkMapScreen() {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <GroupHeaderWrapper>
        <Title>{t('wbs.follow-up-network-map')}</Title>
        <WBSButton as={Link} to="/follow-up-network" wide>
          {t('wbs.view-list')}
        </WBSButton>
      </GroupHeaderWrapper>
      <FollowUpNetworkMapView />
    </PageContainer>
  );
}
